import { render, staticRenderFns } from "./detailRelevancyConfig.vue?vue&type=template&id=29077a8e&scoped=true&"
import script from "./detailRelevancyConfig.vue?vue&type=script&lang=js&"
export * from "./detailRelevancyConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29077a8e",
  null
  
)

export default component.exports